import React from "react";
import { useParams } from "react-router-dom";
import { COMPANY } from "@/lib/api";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "KSPB Enterprises LLP respects your privacy. This policy explains what personal data we collect, how we use it, and your rights.",
    sections: [
      { h: "Information we collect", p: "Name, mobile, email, city, vehicle details, billing/shipping address, and GPS device data for the purpose of tracking services." },
      { h: "How we use your data", p: "To fulfil orders, provide GPS tracking services, offer support, send transactional communications, and comply with legal obligations." },
      { h: "Sharing", p: "We do not sell your data. We share only with delivery, payment (Razorpay), and installation partners strictly to fulfil your order." },
      { h: "Security", p: "Data is stored on secure servers with encryption in transit. Passwords are hashed. Access is restricted to authorised personnel." },
      { h: "Your rights", p: "You may request access, correction or deletion of your personal data by emailing " + COMPANY.email + "." },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "By using this website and purchasing our products, you agree to the following terms.",
    sections: [
      { h: "Use of website", p: "You agree to use the site lawfully and not attempt to disrupt its operations or infringe intellectual property." },
      { h: "Product information", p: "We aim for accuracy but do not warrant that all information is error-free. Prices may change without notice." },
      { h: "Subscription services", p: "GPS tracking platform access is billed monthly or yearly. Subscriptions renew automatically unless cancelled 7 days before renewal." },
      { h: "Liability", p: "KSPB is not liable for indirect damages arising from device misuse, network unavailability, or third-party service failures." },
      { h: "Governing law", p: "Disputes are subject to the exclusive jurisdiction of the courts in Jaipur, Rajasthan." },
    ],
  },
  refund: {
    title: "Refund & Cancellation Policy",
    intro: "We want you to be satisfied with your purchase. Please review our refund terms carefully.",
    sections: [
      { h: "Order cancellation", p: "Orders can be cancelled free of cost before shipment. Once shipped, cancellations follow the return policy below." },
      { h: "Returns", p: "Unused devices in original packaging can be returned within 7 days of delivery. Return shipping is the customer's responsibility unless the item is defective." },
      { h: "Non-refundable", p: "Installed devices, installation charges, and used subscriptions are non-refundable." },
      { h: "Refund timeline", p: "Approved refunds are processed within 7-10 business days to the original payment method." },
      { h: "Warranty claims", p: "Manufacturer warranty covers hardware defects. Contact " + COMPANY.email + " with proof of purchase to initiate a claim." },
    ],
  },
  shipping: {
    title: "Shipping & Delivery Policy",
    intro: "We ship GPS devices across India using trusted courier partners.",
    sections: [
      { h: "Dispatch time", p: "Most orders are dispatched within 1-2 business days of successful payment." },
      { h: "Delivery time", p: "Metro cities: 2-4 business days. Other locations: 4-7 business days. Remote pincodes may take longer." },
      { h: "Shipping charges", p: "Shipping is free for prepaid orders above ₹2,999. For lower value or COD, standard courier charges apply and are shown at checkout." },
      { h: "Tracking", p: "You'll receive a tracking link on SMS / email once the order is dispatched. You can also use the Track Order page." },
      { h: "Undelivered orders", p: "If unable to deliver after 2 attempts, the courier returns the parcel; we then reach out to reschedule or refund." },
    ],
  },
};

export default function PolicyPage() {
  const { type } = useParams();
  const c = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid={`policy-${type}`}>
      <div className="eyebrow">Policy</div>
      <h1 className="font-heading text-4xl font-bold text-[#0A192F] mt-3">{c.title}</h1>
      <p className="mt-4 text-slate-600">{c.intro}</p>
      <div className="mt-8 space-y-6">
        {c.sections.map((s) => (
          <div key={s.h}>
            <h3 className="font-heading text-lg font-semibold text-[#0A192F]">{s.h}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.p}</p>
          </div>
        ))}
      </div>
      <p className="mt-10 text-xs text-slate-500">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>
    </div>
  );
}
